// extracted by mini-css-extract-plugin
module.exports = {"profilePageWrapper":"SelectedUserProfilePage_profilePageWrapper__ZyeTN"};